export const URL = 'https://pfaapi.rehagro.com.br/api';
export const HML = 'https://pfa.rehagro.com.br';
export const URLBI = `https://pfabi.rehagro.com.br/api/`;
